import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const WS_URL = `${BACKEND_URL.replace(/^http/, 'ws')}/api/ws`;

export const api = axios.create({ baseURL: API });

export const connectWS = (onMessage) => {
  let ws = null;
  let stopped = false;
  let ping = null;
  const open = () => {
    ws = new WebSocket(`${WS_URL}?token=${getToken()}`);
    ws.onmessage = (e) => {
      try { onMessage(JSON.parse(e.data)); } catch {}
    };
    ws.onclose = () => { if (!stopped) setTimeout(open, 3000); };
  };
  open();
  ping = setInterval(() => {
    if (ws?.readyState === WebSocket.OPEN) ws.send(JSON.stringify({ type: 'ping' }));
  }, 25000);
  return {
    stop: () => { stopped = true; clearInterval(ping); if (ws) ws.close(); },
    send: (m) => { if (ws?.readyState === WebSocket.OPEN) ws.send(JSON.stringify(m)); },
  };
};

export const getToken = () => localStorage.getItem('snd_token');
export const setToken = (t) => (t ? localStorage.setItem('snd_token', t) : localStorage.removeItem('snd_token'));

api.interceptors.request.use((c) => {
  const t = getToken();
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});
api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !String(e.config?.url || '').includes('/auth/login')) {
      setToken(null);
      window.dispatchEvent(new Event('snd-logout'));
    }
    return Promise.reject(e);
  }
);

export const inr = (n) => '₹' + Math.round(Number(n || 0)).toLocaleString('en-IN');

export const timeAgo = (iso) => {
  if (!iso) return '—';
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return 'just now';
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};

export const STATUS_STYLES = {
  'Open': 'bg-sky-100 text-sky-800 border-sky-300',
  'In-Progress': 'bg-violet-100 text-violet-800 border-violet-300',
  'High-Priority': 'bg-red-100 text-red-700 border-red-300',
  'Closed': 'bg-emerald-100 text-emerald-800 border-emerald-300',
};
